import MuiTab, { TabProps as MuiTabProps } from '@mui/material/Tab';
import * as React from 'react';

export interface TabProps extends MuiTabProps {}

export const Tab = (props: TabProps) => {
  return <MuiTab {...props} />;
};
